var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleChevronTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 23c-6.07513225 0-11-4.9248678-11-11 0-6.07513225 4.92486775-11 11-11 6.0751322 0 11 4.92486775 11 11 0 6.0751322-4.9248678 11-11 11zm0-2c4.9705627 0 9-4.0294373 9-9 0-4.97056275-4.0294373-9-9-9-4.97056275 0-9 4.02943725-9 9 0 4.9705627 4.02943725 9 9 9zm-3.29289322-6.2928932-1.41421356-1.4142136 4.70710678-4.70710676 4.7071068 4.70710676-1.4142136 1.4142136-3.2928932-3.2928932z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronTop);
export default __webpack_public_path__ + "static/media/circle-chevron-top.2defd471380c4cf4806a5e86e9915191.svg";
export { ForwardRef as ReactComponent };